<template>
    <section class="section-toggle deals" v-if="count">
        <div class="body">
            <h3>Last minute deals</h3>
            <span>Show only the properties that are part of the last minute deals.</span>
        </div>
        <toggle v-model="casiola.state.advancedFilters.deal"></toggle>
    </section>
</template>
<script>
import gql from 'graphql-tag'
import { watch, ref, computed } from 'vue'
import { useCasiolaStore } from '@/store'
import Toggle from '@vueform/toggle'
import { useQuery } from '@vue/apollo-composable'

const query = gql`query Units($destinationIds: [Int], $deal: Boolean, $checkin: String, $checkout: String) {
  units(destinationIds: $destinationIds, deal: $deal, checkin: $checkin, checkout: $checkout) {
    total
  }
}`

export default {
    components: { Toggle },
    setup() {
        // CASIOLA STORE
        const casiola = useCasiolaStore()

        const count = ref(0)
        const filter = computed(() => {
            return {
                destinationIds: casiola.state.baseFilters.destinations.length ? casiola.state.baseFilters.destinations : null,
                checkin: casiola.state.baseFilters.date.start ? casiola.state.baseFilters.date.start.toFormat('yyyy-MM-dd') : null,
                checkout: casiola.state.baseFilters.date.end ? casiola.state.baseFilters.date.end.toFormat('yyyy-MM-dd') : null,
                deal: true
            }
        })
        const onQueryResult = (data) => {
            count.value = data.units.total
        }
        const { result, onResult } = useQuery(query, filter);
        const handleResult = (data) => {
            onQueryResult(data)
        };
        watch(result, () => {
            if (!result.value) {
                return;
            }
            handleResult(result.value);
        }, {
            immediate: true
        });
        onResult(({ data }) => {
            if (data) {
                onQueryResult(data)
            }
        });

        return {
            casiola,
            count
        }
    }
}
</script>
<style lang="scss" scoped>
.section-toggle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1em;

    color: #f09;
    background: #FFE5F5;

    h3 {
        color: inherit;
        font-size: 1.43em;
        font-weight: 400;
        margin-bottom: .5rem;
    }
}
</style>
<style src="@vueform/toggle/themes/default.css">
</style>